const e = [
  0,
  "0.8rem",
  "1.6rem",
  "2.4rem",
  "3.2rem",
  "6.4rem"
];
e.xs = e[1];
e.sm = e[2];
e.md = e[3];
e.lg = e[4];
e.xl = e[5];
export {
  e as default
};
